import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GroupParticipants from '../../Legacy/GroupParticipants';
import ConversationParticipantsListResponsiveContainer from './ConversationParticipantsListResponsiveContainer';
import {
  selectorsResponsive as selectors,
  operationsResponsive as creators,
} from '../../../../../../store/conversations';
import { ConversationIcon } from './RenameGroupModal.styled';

const stopPropagation = (e) => e.stopPropagation();

const addParticipants = (participantIds) =>
  creators.addParticipants(participantIds);
const changeGroupName = (title) => creators.renameConversation(title);
const removeParticipant = (participantId) =>
  creators.removeParticipant(participantId);

const compareParticipants = (p1, p2) => {
  const s1 = `${p1.firstName} ${p1.lastName}`;
  const s2 = `${p2.firstName} ${p2.lastName}`;
  return s1 < s2 ? -1 : 1;
};

const mapStateToProps = (state, ownProps) => {
  const conversationTitle = selectors.conversationTitle(
    state,
    ownProps.conversation.id
  );
  return {
    // Common props for both components
    addParticipantsFirst: state.inboxv2.addParticipantOpened,
    classRoomId: state.classRoom.current,
    groupId: ownProps.conversation.id,
    groupName: conversationTitle,
    icon: () => React.createElement(ConversationIcon, ownProps),
    open: state.inboxv2.viewParticipantsOpened,
    onClick: stopPropagation,
    participants: Object.keys(ownProps.conversation.participants)
      .map((id) => state.data.users[id])
      .filter((u) => !!u)
      .sort(compareParticipants),
    title: conversationTitle,
    userId: state.user.userId,
    boundToSpaceGroup: !!ownProps.conversation.boundToSpaceGroup,
    conversation: ownProps.conversation, // Add missing conversation prop

    // Additional props for the new responsive component
    openn: state.inboxv2.viewParticipantsOpened,
    educatorOnly: !!ownProps.conversation.educatorOnly,
    conversationData: ownProps.conversation,
  };
};

const mapDispatchToProps = {
  addParticipants,
  changeGroupName,
  handleClose: creators.closeViewParticipants,
  removeParticipant,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  handleClose: (...params) => {
    dispatchProps.handleClose(...params);
    ownProps.onClose();
  },
});

// Wrapper component that conditionally renders the appropriate component
const ViewParticipantsModalWrapper = (props) => {
  const { addParticipantsFirst, ...otherProps } = props;

  // If we're in "add participants" mode, use the original GroupParticipants component
  if (addParticipantsFirst) {
    return React.createElement(GroupParticipants, otherProps);
  }

  // Otherwise, use the new responsive component for viewing participants
  return React.createElement(
    ConversationParticipantsListResponsiveContainer,
    otherProps
  );
};

ViewParticipantsModalWrapper.propTypes = {
  addParticipantsFirst: PropTypes.bool,
};

ViewParticipantsModalWrapper.defaultProps = {
  addParticipantsFirst: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ViewParticipantsModalWrapper);
